import { render, staticRenderFns } from "./TruncatedCopyableList.vue?vue&type=template&id=7673b950"
import script from "./TruncatedCopyableList.vue?vue&type=script&lang=ts"
export * from "./TruncatedCopyableList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports